import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, Suspense as _Suspense, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 lg:col-3 hidable-column" }
const _hoisted_5 = {
  key: 0,
  class: "card"
}
const _hoisted_6 = {
  key: 1,
  class: "card"
}
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = {
  key: 2,
  class: "card"
}
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_19 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_20 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_21 = {
  key: 3,
  class: "p-fluid"
}
const _hoisted_22 = { class: "p-fluid" }
const _hoisted_23 = { class: "p-fluid" }
const _hoisted_24 = { class: "p-fluid" }
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = {
  key: 5,
  class: "p-fluid"
}
const _hoisted_27 = {
  key: 6,
  class: "p-fluid"
}
const _hoisted_28 = {
  key: 7,
  class: "p-fluid"
}
const _hoisted_29 = { class: "col-12 lg:col-3 hidable-column" }
const _hoisted_30 = {
  key: 0,
  class: "card"
}
const _hoisted_31 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_32 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_33 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_34 = { class: "p-fluid" }
const _hoisted_35 = { class: "p-fluid" }
const _hoisted_36 = {
  key: 5,
  class: "card"
}
const _hoisted_37 = { class: "p-fluid" }
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = { class: "p-fluid" }
const _hoisted_40 = { class: "p-fluid" }
const _hoisted_41 = { class: "card" }
const _hoisted_42 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_43 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_44 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_45 = { class: "p-fluid" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "col-12 lg:col-3 hidable-column" }
const _hoisted_48 = {
  key: 0,
  class: "card"
}
const _hoisted_49 = { class: "p-fluid" }
const _hoisted_50 = { class: "p-fluid" }
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_53 = {
  key: 1,
  class: "card"
}
const _hoisted_54 = { class: "p-fluid" }
const _hoisted_55 = {
  key: 2,
  class: "card"
}
const _hoisted_56 = { class: "p-fluid" }
const _hoisted_57 = {
  key: 3,
  class: "card"
}
const _hoisted_58 = { class: "p-fluid" }
const _hoisted_59 = {
  key: 4,
  class: "card"
}
const _hoisted_60 = { class: "p-fluid" }
const _hoisted_61 = {
  key: 5,
  class: "card"
}
const _hoisted_62 = { class: "p-fluid" }
const _hoisted_63 = { class: "p-fluid" }
const _hoisted_64 = { class: "p-fluid" }
const _hoisted_65 = { class: "p-fluid" }
const _hoisted_66 = { class: "p-fluid" }
const _hoisted_67 = { class: "p-fluid" }
const _hoisted_68 = {
  key: 7,
  class: "card"
}
const _hoisted_69 = { class: "p-fluid" }
const _hoisted_70 = { class: "p-fluid" }
const _hoisted_71 = { class: "col-12 lg:col-3 hidable-column" }
const _hoisted_72 = { class: "card" }
const _hoisted_73 = { class: "p-fluid" }
const _hoisted_74 = {
  key: 0,
  class: "card"
}
const _hoisted_75 = {
  key: 1,
  class: "card"
}
const _hoisted_76 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_77 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_78 = {
  key: 2,
  class: "card"
}
const _hoisted_79 = { class: "p-fluid" }
const _hoisted_80 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_EndpointMeta = _resolveComponent("EndpointMeta")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_CustomRevshares = _resolveComponent("CustomRevshares")!
  const _component_ShaveRules = _resolveComponent("ShaveRules")!
  const _component_FieldBidCPM = _resolveComponent("FieldBidCPM")!
  const _component_CustomBids = _resolveComponent("CustomBids")!
  const _component_FieldDate = _resolveComponent("FieldDate")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_FieldListBox = _resolveComponent("FieldListBox")!
  const _component_PusherStats = _resolveComponent("PusherStats")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_Entry = _resolveComponent("Entry")!

  return (_openBlock(), _createBlock(_component_Entry, {
    title: _ctx.$t('endpoint'),
    entry: _ctx.endpoint,
    "entry-fetch-handler": _ctx.fetchEndpoint,
    "entry-store-handler": _ctx.user.isAffiliate() ? null : _ctx.storeEndpoint,
    "entry-errors-map": _ctx.endpointErrorsMap,
    "onUpdate:entryErrorsMap": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.endpointErrorsMap) = $event))
  }, {
    "buttons-col-2-prepend": _withCtx(() => [
      (_ctx.user.isStaff() && !!_ctx.endpoint.id && !_ctx.isDirectLink)
        ? (_openBlock(), _createBlock(_component_PrimeVueButton, {
            key: 0,
            class: "p-button-secondary ml-4 mb-0",
            label: _ctx.$t('clone'),
            icon: "pi pi-copy",
            onClick: _ctx.cloneEndpoint
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.user.isStaff() && !!_ctx.endpoint.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("a", {
              class: "ml-4",
              href: `/users/${_ctx.endpoint.user_id}`,
              target: "_blank"
            }, [
              _createVNode(_component_PrimeVueButton, {
                class: "p-button-info mb-0",
                label: _ctx.$t('user'),
                icon: "pi pi-user"
              }, null, 8, ["label"])
            ], 8, _hoisted_1),
            (!!_ctx.endpoint.site_id)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "ml-4",
                  href: `/sites/${_ctx.endpoint.site_id}`,
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimeVueButton, {
                    class: "p-button-info mb-0",
                    label: _ctx.$t('site'),
                    icon: "pi pi-desktop"
                  }, null, 8, ["label"])
                ], 8, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!!_ctx.endpoint.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_EndpointMeta, {
                      endpoint: _ctx.endpoint,
                      "show-compiled-name": "",
                      "show-uuid": ""
                    }, null, 8, ["endpoint"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, {
                      class: "mb-4",
                      height: "10px"
                    })
                  ]),
                  _: 1
                }))
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isSuperAdmin())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.project_id,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.endpoint.project_id) = $event)),
                      _ctx.onProjectChange
                    ],
                    modelModifiers: { number: true },
                    name: "project_id",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('project'),
                    loading: _ctx.projectsLoading,
                    disabled: !!_ctx.endpoint.id,
                    options: _ctx.projects.data,
                    "option-value": "id",
                    "option-label": "name"
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_FieldDropdownAutoComplete, {
                    modelValue: _ctx.endpoint.user_id,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endpoint.user_id) = $event)),
                      _ctx.onUserChange
                    ],
                    modelModifiers: { number: true },
                    name: "user_id",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('user'),
                    disabled: !!_ctx.endpoint.id,
                    "api-url": "/api/v3/users/options",
                    "api-params": _ctx.usersParams,
                    "option-label": "compiled_name"
                  }, null, 8, ["modelValue", "errors-map", "label", "disabled", "api-params", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_FieldDropdownAutoComplete, {
                modelValue: _ctx.endpoint.site_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endpoint.site_id) = $event)),
                modelModifiers: { number: true },
                name: "site_id",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('site'),
                disabled: !!_ctx.endpoint.id,
                "api-url": "/api/v3/sites/options",
                "api-params": _ctx.sitesParams,
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "api-params"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (!_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.traffic_type,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endpoint.traffic_type) = $event)),
                      _ctx.onTrafficTypeChange
                    ],
                    modelModifiers: { number: true },
                    name: "traffic_type",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('type'),
                    disabled: !!_ctx.endpoint.id,
                    options: _ctx.trafficTypes
                  }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.endpoint.traffic_category,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endpoint.traffic_category) = $event)),
                  _ctx.onTrafficCategoryChange
                ],
                modelModifiers: { number: true },
                name: "traffic_category",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('category'),
                disabled: !!_ctx.endpoint.id,
                options: _ctx.TRAFFIC_CATEGORIES
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"])
            ]),
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.direct,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endpoint.direct) = $event)),
                    label: "Direct",
                    help: "Classify traffic as \"Direct\""
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[60] || (_cache[60] = _createElementVNode("h6", null, "Integration settings 🔌", -1)),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.endpoint.protocol,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endpoint.protocol) = $event)),
                  _ctx.onProtocolChange
                ],
                modelModifiers: { number: true },
                name: "protocol",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('protocol'),
                disabled: _ctx.user.isAffiliate(),
                options: _ctx.protocols,
                "option-label-translate": ""
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"])
            ]),
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.custom_response_provider,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endpoint.custom_response_provider) = $event)),
                      _ctx.onCustomResponseProviderChange
                    ],
                    modelModifiers: { number: true },
                    name: "custom_response_provider",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Provider",
                    "show-clear": "",
                    disabled: _ctx.user.isAffiliate(),
                    options: _ctx.CUSTOM_RESPONSE_PROVIDERS
                  }, null, 8, ["modelValue", "errors-map", "disabled", "options", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.max_qps,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endpoint.max_qps) = $event)),
                    modelModifiers: { number: true },
                    name: "max_qps",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('max_qps'),
                    options: _ctx.ENDPOINT_MAX_QPS
                  }, null, 8, ["modelValue", "errors-map", "label", "options"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.region,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.endpoint.region) = $event)),
                    modelModifiers: { number: true },
                    name: "region",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('region'),
                    disabled: _ctx.user.isAffiliate(),
                    options: _ctx.regions,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && _ctx.isLegacy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.get_ip_and_user_agent_from_headers,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.endpoint.get_ip_and_user_agent_from_headers) = $event)),
                    label: "Use request headers",
                    help: "Extract IP and User-Agent from HTTP headers instead of URL parameters"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_FieldText, {
                      modelValue: _ctx.endpoint.click_host_eu,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endpoint.click_host_eu) = $event)),
                      modelModifiers: { trim: true },
                      name: "click_host_eu",
                      "errors-map": _ctx.endpointErrorsMap,
                      label: "Custom click-domain for eu. subdomain"
                    }, null, 8, ["modelValue", "errors-map"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_FieldText, {
                      modelValue: _ctx.endpoint.click_host_us,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endpoint.click_host_us) = $event)),
                      modelModifiers: { trim: true },
                      name: "click_host_us",
                      "errors-map": _ctx.endpointErrorsMap,
                      label: "Custom click-domain for us. subdomain"
                    }, null, 8, ["modelValue", "errors-map"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_FieldText, {
                      modelValue: _ctx.endpoint.click_host_sg,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.endpoint.click_host_sg) = $event)),
                      modelModifiers: { trim: true },
                      name: "click_host_sg",
                      "errors-map": _ctx.endpointErrorsMap,
                      label: "Custom click-domain for sg. subdomain"
                    }, null, 8, ["modelValue", "errors-map"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_FieldText, {
                      modelValue: _ctx.endpoint.click_host_in,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.endpoint.click_host_in) = $event)),
                      modelModifiers: { trim: true },
                      name: "click_host_in",
                      "errors-map": _ctx.endpointErrorsMap,
                      label: "Custom click-domain for in. subdomain"
                    }, null, 8, ["modelValue", "errors-map"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.user.isLimitedManager() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.hide_pseudosite_host_in_click_url,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.endpoint.hide_pseudosite_host_in_click_url) = $event)),
                    label: "Mask pseudosite domain",
                    help: "Use a common or custom click domain in click URL instead of the pseudosite domain"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.user.isLimitedManager() && !_ctx.isPop && !_ctx.isVideo && _ctx.endpoint.allow_feeds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.replace_feeds_responses,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.endpoint.replace_feeds_responses) = $event)),
                    label: "Override feed content",
                    help: "Replace titles and descriptions in the feed response with predefined values"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.user.isLimitedManager() && _ctx.isLegacy && !_ctx.endpoint.custom_response_provider)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.show_ad_id,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.endpoint.show_ad_id) = $event)),
                    label: "Include encoded Ad ID",
                    help: "Include the ad_id field to the response with a Base32-encoded Feed or Campaign ID"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (!_ctx.isDirectLink)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.endpoint.bid_type,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.endpoint.bid_type) = $event)),
                        modelModifiers: { number: true },
                        name: "bid_type",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: "Bid scale",
                        help: _ctx.$t('bid_type_help'),
                        options: _ctx.BID_TYPES
                      }, null, 8, ["modelValue", "errors-map", "help", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isPop && !_ctx.isVideo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.endpoint.bid_subject,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.endpoint.bid_subject) = $event)),
                        modelModifiers: { number: true },
                        name: "bid_subject",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: "Bid event",
                        options: _ctx.BID_SUBJECTS
                      }, null, 8, ["modelValue", "errors-map", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isVideo && _ctx.endpoint.bid_subject === _ctx.BID_SUBJECT_VIEW)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.endpoint.payable_view_registration,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.endpoint.payable_view_registration) = $event)),
                        modelModifiers: { number: true },
                        name: "payable_view_registration",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: "Payable view registration",
                        options: _ctx.PAYABLE_VIEW_REGISTRATIONS
                      }, null, 8, ["modelValue", "errors-map", "options"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.revshare,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.endpoint.revshare) = $event)),
                    modelModifiers: { number: true },
                    name: "revshare",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('revshare'),
                    min: 1,
                    max: 200,
                    step: 5,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: "%"
                  }, null, 8, ["modelValue", "errors-map", "label"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.shave,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.endpoint.shave) = $event)),
                    modelModifiers: { number: true },
                    name: "shave",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('shave'),
                    min: 0,
                    max: 100,
                    step: 5,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: "%"
                  }, null, 8, ["modelValue", "errors-map", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomRevshares, {
                    modelValue: _ctx.endpoint.revshare_by_countries_ids,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.endpoint.revshare_by_countries_ids) = $event)),
                    title: "RevShare by countries",
                    "entry-title": _ctx.$t('country'),
                    "default-revshare": _ctx.endpoint.revshare
                  }, {
                    key: _withCtx(({ customRevshare }) => [
                      _createVNode(_component_FieldDropdownNext, {
                        class: "mb-0",
                        modelValue: customRevshare.key,
                        "onUpdate:modelValue": ($event: any) => ((customRevshare.key) = $event),
                        loading: _ctx.countriesLoading,
                        "show-clear": "",
                        filter: "",
                        options: _ctx.countries.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "loading", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "entry-title", "default-revshare"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, {
                    class: "mb-4",
                    height: "10px"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomRevshares, {
                    modelValue: _ctx.endpoint.revshare_by_subids_uuids,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.endpoint.revshare_by_subids_uuids) = $event)),
                    title: "RevShare by subids UUIDs",
                    "entry-title": _ctx.$t('subid_uuid'),
                    "default-revshare": _ctx.endpoint.revshare,
                    "key-validator": _ctx.validateUuid,
                    "allow-bulk": ""
                  }, {
                    key: _withCtx(({ customRevshare }) => [
                      _createVNode(_component_FieldText, {
                        modelValue: customRevshare.key,
                        "onUpdate:modelValue": ($event: any) => ((customRevshare.key) = $event),
                        modelModifiers: { trim: true },
                        style: {"margin-bottom":"0 !important"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "entry-title", "default-revshare", "key-validator"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomRevshares, {
                    modelValue: _ctx.endpoint.revshare_by_referrers_uuids,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.endpoint.revshare_by_referrers_uuids) = $event)),
                    title: "RevShare by referrers UUIDs",
                    "entry-title": _ctx.$t('referrer_uuid'),
                    "default-revshare": _ctx.endpoint.revshare,
                    "key-validator": _ctx.validateUuid,
                    "allow-bulk": ""
                  }, {
                    key: _withCtx(({ customRevshare }) => [
                      _createVNode(_component_FieldText, {
                        modelValue: customRevshare.key,
                        "onUpdate:modelValue": ($event: any) => ((customRevshare.key) = $event),
                        modelModifiers: { trim: true },
                        style: {"margin-bottom":"0 !important"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "entry-title", "default-revshare", "key-validator"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_Suspense, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ShaveRules, {
                    class: "mt-4",
                    modelValue: _ctx.endpoint.shave_rules,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.endpoint.shave_rules) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, {
                    class: "mb-4",
                    height: "10px"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.pay_filtered_click_chance,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.endpoint.pay_filtered_click_chance) = $event)),
                    modelModifiers: { number: true },
                    name: "pay_filtered_click_chance",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Filtered click pay-through chance",
                    help: "Always pay for a fixed percentage of filtered clicks, regardless of the Checker decision",
                    min: 0,
                    max: 100,
                    step: 5,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: "%"
                  }, null, 8, ["modelValue", "errors-map"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.min_bid_override,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.endpoint.min_bid_override) = $event)),
                    modelModifiers: { number: true },
                    name: "min_bid_override",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Override min bid",
                    help: "Override the default system floor to allow lower-priced bids into the auction. Use this to increase the volume of participating ads and ensure a more active rotation",
                    min: 0,
                    "min-fraction-digits": 1,
                    "max-fraction-digits": 8,
                    prefix: "$"
                  }, null, 8, ["modelValue", "errors-map"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.campaign_bid_divider,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.endpoint.campaign_bid_divider) = $event)),
                    modelModifiers: { number: true },
                    name: "campaign_bid_divider",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Direct advertiser bid divider",
                    help: "Divide the direct advertiser's bid by this value before the auction. Leave empty or 1 to keep the bid as is",
                    min: 1,
                    max: 100,
                    "min-fraction-digits": 1,
                    "max-fraction-digits": 2,
                    suffix: "x"
                  }, null, 8, ["modelValue", "errors-map"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_FieldBidCPM, {
                    modelValue: _ctx.endpoint.fixed_bid,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.endpoint.fixed_bid) = $event)),
                    modelModifiers: { number: true },
                    name: "fixed_bid",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('fixed_cpm')
                  }, null, 8, ["modelValue", "errors-map", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_component_CustomBids, {
                key: 6,
                class: "mt-3",
                modelValue: _ctx.endpoint.fixed_bid_by_country,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.endpoint.fixed_bid_by_country) = $event)),
                title: "Fixed CPM by countries",
                "entry-title": "Country",
                "price-title": "CPM",
                min: 0
              }, {
                key: _withCtx(({ customBid }) => [
                  _createVNode(_component_FieldDropdownNext, {
                    class: "mb-0",
                    modelValue: customBid.key,
                    "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                    modelModifiers: { number: true },
                    loading: _ctx.countriesLoading,
                    "show-clear": "",
                    filter: "",
                    options: _ctx.countries.data,
                    "option-value": "id",
                    "option-label": "compiled_name"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "loading", "options"])
                ]),
                bid: _withCtx(({ customBid }) => [
                  _createVNode(_component_FieldBidCPM, {
                    class: "mb-0",
                    modelValue: customBid.bid,
                    "onUpdate:modelValue": ($event: any) => ((customBid.bid) = $event),
                    modelModifiers: { number: true },
                    label: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.allow_referrer_mismatch,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.endpoint.allow_referrer_mismatch) = $event)),
                    label: "Bypass referrer mismatch filter",
                    help: "Don't filter clicks where the click referrer does not match the request referrer. Enable this if you trust the traffic source"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.disable_decline_non_effective_subids,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.endpoint.disable_decline_non_effective_subids) = $event)),
                    label: "Bypass subids optimization",
                    help: "Prevent declining subids based on non-effective requests optimization"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff() && !_ctx.isDirectLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createVNode(_component_FieldDate, {
                    modelValue: _ctx.endpoint.subids_checking_delay_to,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.endpoint.subids_checking_delay_to) = $event)),
                    label: "Bypass Checker until",
                    help: "Don't check subids until the selected date",
                    "show-time": ""
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_FieldTextarea, {
                modelValue: _ctx.endpoint.passback_url,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.endpoint.passback_url) = $event)),
                modelModifiers: { trim: true },
                name: "passback_url",
                "errors-map": _ctx.endpointErrorsMap,
                label: "Trafficback URL",
                disabled: _ctx.user.isAffiliate(),
                rows: 2
              }, null, 8, ["modelValue", "errors-map", "disabled"]),
              (!_ctx.user.isAffiliate())
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.$t('available_macros')) + ":", 1),
                    _cache[61] || (_cache[61] = _createElementVNode("div", null, [
                      _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{endpoint_id}"),
                      _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{endpoint_uuid}"),
                      _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subid}"),
                      _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subid_uuid}"),
                      _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{reason}")
                    ], -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _cache[62] || (_cache[62] = _createElementVNode("h6", null, "Rotation settings", -1)),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.allow_feeds,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.endpoint.allow_feeds) = $event)),
                    label: "Include feeds"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.allow_campaigns,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.endpoint.allow_campaigns) = $event)),
                    label: "Include campaigns"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.sensitive,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.endpoint.sensitive) = $event)),
                    label: "Exclude suspicious supply",
                    help: "Exclude feeds and campaigns flagged by AdSecure as suspicious or unsafe"
                  }, null, 8, ["modelValue"])
                ]),
                (_ctx.endpoint.traffic_category === _ctx.TRAFFIC_CATEGORY_MAINSTREAM)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createVNode(_component_FieldCheckbox, {
                        modelValue: _ctx.endpoint.only_mainstream_coverage,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.endpoint.only_mainstream_coverage) = $event)),
                        label: "Exclude adult supply 🍓"
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.endpoint.direct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.jerk_feeds_retries,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.endpoint.jerk_feeds_retries) = $event)),
                    modelModifiers: { number: true },
                    name: "jerk_feeds_retries",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Jerk feeds 💦",
                    help: "Use for aggressive feed polling to get a non-204 response and secure a higher bid",
                    min: 0,
                    max: 50,
                    step: 1,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: " retries"
                  }, null, 8, ["modelValue", "errors-map"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.endpoint.allow_feeds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('feeds')), 1),
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.targeting_by_feeds_ids,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.endpoint.targeting_by_feeds_ids) = $event)),
                    modelModifiers: { number: true },
                    name: "targeting_by_feeds_ids",
                    label: _ctx.$t('targeting_type'),
                    options: _ctx.TARGETING_TYPES,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "label", "options"]),
                  (_ctx.endpoint.targeting_by_feeds_ids !== _ctx.TARGETING_TYPE_DISABLED)
                    ? (_openBlock(), _createBlock(_component_FieldListBox, {
                        key: 0,
                        modelValue: _ctx.endpoint.feeds_ids,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.endpoint.feeds_ids) = $event)),
                        name: "feeds_ids",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: _ctx.$t('feeds'),
                        loading: _ctx.feedsLoading,
                        options: _ctx.feeds.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.endpoint.allow_campaigns)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('advertisers')), 1),
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.targeting_by_advertisers_ids,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.endpoint.targeting_by_advertisers_ids) = $event)),
                    modelModifiers: { number: true },
                    name: "targeting_by_advertisers_ids",
                    label: _ctx.$t('targeting_type'),
                    options: _ctx.TARGETING_TYPES,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "label", "options"]),
                  (_ctx.endpoint.targeting_by_advertisers_ids !== _ctx.TARGETING_TYPE_DISABLED)
                    ? (_openBlock(), _createBlock(_component_FieldListBox, {
                        key: 0,
                        modelValue: _ctx.endpoint.advertisers_ids,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.endpoint.advertisers_ids) = $event)),
                        name: "advertisers_ids",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: _ctx.$t('advertisers'),
                        loading: _ctx.advertisersLoading,
                        options: _ctx.advertisers.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.endpoint.allow_campaigns)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('campaigns')), 1),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.endpoint.targeting_by_campaigns,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.endpoint.targeting_by_campaigns) = $event)),
                    modelModifiers: { number: true },
                    name: "targeting_by_campaigns",
                    label: _ctx.$t('targeting_type'),
                    options: _ctx.TARGETING_TYPES,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "label", "options"]),
                  (_ctx.endpoint.targeting_by_campaigns !== _ctx.TARGETING_TYPE_DISABLED)
                    ? (_openBlock(), _createBlock(_component_FieldListBox, {
                        key: 0,
                        modelValue: _ctx.endpoint.campaigns_ids,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.endpoint.campaigns_ids) = $event)),
                        name: "campaigns_ids",
                        "errors-map": _ctx.endpointErrorsMap,
                        label: _ctx.$t('campaigns'),
                        loading: _ctx.campaignsLoading,
                        options: _ctx.campaigns.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && _ctx.isPush)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _cache[63] || (_cache[63] = _createElementVNode("h6", null, "Pusher settings 🔔", -1)),
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_delay_to_first_sending,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.endpoint.push_delay_to_first_sending) = $event)),
                    modelModifiers: { number: true },
                    name: "push_delay_to_first_sending",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Delay to first sending",
                    min: 0,
                    step: 30,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_delay_to_sending,
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.endpoint.push_delay_to_sending) = $event)),
                    modelModifiers: { number: true },
                    name: "push_delay_to_sending",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Delay between sendings",
                    min: 0,
                    step: 30,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_delay_to_sending_mature,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.endpoint.push_delay_to_sending_mature) = $event)),
                    modelModifiers: { number: true },
                    name: "push_delay_to_sending_mature",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Delay between sendings for subscriptions 5+ days",
                    help: "Optional",
                    min: 0,
                    step: 30,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_max_sendings,
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.endpoint.push_max_sendings) = $event)),
                    modelModifiers: { number: true },
                    name: "push_max_sendings",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Max sendings",
                    min: 0,
                    step: 25,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus"
                  }, null, 8, ["modelValue", "errors-map"])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.push_max_age,
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.endpoint.push_max_age) = $event)),
                    modelModifiers: { number: true },
                    name: "push_max_age",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Max age",
                    min: 1,
                    step: 1,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus"
                  }, null, 8, ["modelValue", "errors-map"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_FieldCheckbox, {
                    modelValue: _ctx.endpoint.push_quiet_hour,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.endpoint.push_quiet_hour) = $event)),
                    label: "Quiet hours",
                    help: "Do not send notifications between 21:00 and 9:00"
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isSuperAdmin() && !!_ctx.endpoint.id && _ctx.isPush)
            ? (_openBlock(), _createBlock(_component_PusherStats, {
                key: 6,
                "endpoint-id": _ctx.endpoint.id
              }, null, 8, ["endpoint-id"]))
            : _createCommentVNode("", true),
          ( _ctx.user.isStaff() && _ctx.isDirectLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _cache[64] || (_cache[64] = _createElementVNode("h6", null, "JS pop code settings", -1)),
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_FieldNumber, {
                    modelValue: _ctx.endpoint.pop_frequency_seconds,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.endpoint.pop_frequency_seconds) = $event)),
                    modelModifiers: { number: true },
                    name: "pop_frequency_seconds",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: _ctx.$t('pop_frequency_seconds'),
                    help: _ctx.$t('pop_frequency_seconds_help'),
                    min: 0,
                    step: 60,
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus",
                    suffix: ` ${_ctx.$t('sec')}`
                  }, null, 8, ["modelValue", "errors-map", "label", "help", "suffix"])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.endpoint.pop_targeting_by_countries,
                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.endpoint.pop_targeting_by_countries) = $event)),
                    modelModifiers: { number: true },
                    name: "pop_targeting_by_countries",
                    "errors-map": _ctx.endpointErrorsMap,
                    label: "Countries",
                    options: _ctx.TARGETING_TYPES
                  }, null, 8, ["modelValue", "errors-map", "options"]),
                  (_ctx.endpoint.pop_targeting_by_countries !== _ctx.TARGETING_TYPE_DISABLED)
                    ? (_openBlock(), _createBlock(_component_FieldListBox, {
                        key: 0,
                        modelValue: _ctx.endpoint.pop_countries_ids,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.endpoint.pop_countries_ids) = $event)),
                        loading: _ctx.countriesLoading,
                        options: _ctx.countries.data,
                        "option-value": "id",
                        "option-label": "compiled_name"
                      }, null, 8, ["modelValue", "loading", "options"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.endpoint.status,
                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.endpoint.status) = $event)),
                modelModifiers: { number: true },
                name: "status",
                "errors-map": _ctx.endpointErrorsMap,
                label: _ctx.$t('status'),
                disabled: _ctx.user.isAffiliate(),
                options: _ctx.ENDPOINT_STATUSES,
                "option-label-translate": ""
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
            ])
          ]),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createVNode(_component_FieldTextarea, {
                  modelValue: _ctx.endpoint.comment,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.endpoint.comment) = $event)),
                  modelModifiers: { trim: true },
                  name: "comment",
                  "errors-map": _ctx.endpointErrorsMap,
                  label: _ctx.$t('comment')
                }, null, 8, ["modelValue", "errors-map", "label"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff() && !!_ctx.endpoint.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _createElementVNode("h6", null, _toDisplayString(_ctx.$t('declined_subids')), 1),
                _createVNode(_component_PrimeVueButton, {
                  class: "p-button-secondary w-full",
                  label: _ctx.$t('show'),
                  loading: _ctx.declinedSubidsLoading,
                  onClick: _ctx.getDeclinedSubids
                }, null, 8, ["label", "loading", "onClick"]),
                (_ctx.showDeclinedSubids)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      (_ctx.declinedSubids.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createVNode(_component_FieldDropdown, {
                              modelValue: _ctx.declinedSubidsAsStringSeparator,
                              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.declinedSubidsAsStringSeparator) = $event)),
                              label: _ctx.$t('separator'),
                              options: _ctx.declinedSubidsAsStringSeparators
                            }, null, 8, ["modelValue", "label", "options"]),
                            _createVNode(_component_FieldTextarea, {
                              "model-value": _ctx.declinedSubidsAsString,
                              help: `${_ctx.declinedSubids.length} ${_ctx.$t('subids').toLowerCase()}`,
                              disabled: ""
                            }, null, 8, ["model-value", "help"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('nothing')), 1)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!!_ctx.endpoint.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_FieldText, {
                    "model-value": _ctx.endpoint.created_at,
                    label: _ctx.$t('created_at'),
                    disabled: ""
                  }, null, 8, ["model-value", "label"])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_FieldText, {
                    "model-value": _ctx.endpoint.updated_at,
                    label: _ctx.$t('updated_at'),
                    disabled: ""
                  }, null, 8, ["model-value", "label"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "entry", "entry-fetch-handler", "entry-store-handler", "entry-errors-map"]))
}